"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_core_1 = require("@datadog/browser-core");
var getActionNameFromElement_1 = require("./getActionNameFromElement");
var lifeCycle_1 = require("./lifeCycle");
var trackEventCounts_1 = require("./trackEventCounts");
var trackPageActivities_1 = require("./trackPageActivities");
var UserActionType;
(function (UserActionType) {
    UserActionType["CLICK"] = "click";
    UserActionType["CUSTOM"] = "custom";
})(UserActionType = exports.UserActionType || (exports.UserActionType = {}));
function startUserActionCollection(lifeCycle) {
    var userAction = startUserActionManagement(lifeCycle);
    // New views trigger the discard of the current pending User Action
    lifeCycle.subscribe(lifeCycle_1.LifeCycleEventType.VIEW_CREATED, function () {
        userAction.discardCurrent();
    });
    addEventListener(browser_core_1.DOM_EVENT.CLICK, processClick, { capture: true });
    function processClick(event) {
        if (!(event.target instanceof Element)) {
            return;
        }
        var name = getActionNameFromElement_1.getActionNameFromElement(event.target);
        if (!name) {
            return;
        }
        userAction.create(UserActionType.CLICK, name);
    }
    return {
        stop: function () {
            userAction.discardCurrent();
            removeEventListener(browser_core_1.DOM_EVENT.CLICK, processClick, { capture: true });
        },
    };
}
exports.startUserActionCollection = startUserActionCollection;
function startUserActionManagement(lifeCycle) {
    var currentUserAction;
    var currentIdlePageActivitySubscription;
    return {
        create: function (type, name) {
            if (currentUserAction) {
                // Ignore any new user action if another one is already occurring.
                return;
            }
            var pendingAutoUserAction = new PendingAutoUserAction(lifeCycle, type, name);
            currentUserAction = pendingAutoUserAction;
            currentIdlePageActivitySubscription = trackPageActivities_1.waitIdlePageActivity(lifeCycle, function (hadActivity, endTime) {
                if (hadActivity) {
                    pendingAutoUserAction.complete(endTime);
                }
                else {
                    pendingAutoUserAction.discard();
                }
                currentUserAction = undefined;
            });
        },
        discardCurrent: function () {
            if (currentUserAction) {
                currentIdlePageActivitySubscription.stop();
                currentUserAction.discard();
                currentUserAction = undefined;
            }
        },
    };
}
var PendingAutoUserAction = /** @class */ (function () {
    function PendingAutoUserAction(lifeCycle, type, name) {
        this.lifeCycle = lifeCycle;
        this.type = type;
        this.name = name;
        this.id = browser_core_1.generateUUID();
        this.startTime = performance.now();
        this.eventCountsSubscription = trackEventCounts_1.trackEventCounts(lifeCycle);
        this.lifeCycle.notify(lifeCycle_1.LifeCycleEventType.AUTO_ACTION_CREATED, { id: this.id, startTime: this.startTime });
    }
    PendingAutoUserAction.prototype.complete = function (endTime) {
        var eventCounts = this.eventCountsSubscription.eventCounts;
        this.lifeCycle.notify(lifeCycle_1.LifeCycleEventType.AUTO_ACTION_COMPLETED, {
            duration: endTime - this.startTime,
            id: this.id,
            measures: {
                errorCount: eventCounts.errorCount,
                longTaskCount: eventCounts.longTaskCount,
                resourceCount: eventCounts.resourceCount,
            },
            name: this.name,
            startTime: this.startTime,
            type: this.type,
        });
        this.eventCountsSubscription.stop();
    };
    PendingAutoUserAction.prototype.discard = function () {
        this.lifeCycle.notify(lifeCycle_1.LifeCycleEventType.AUTO_ACTION_DISCARDED);
        this.eventCountsSubscription.stop();
    };
    return PendingAutoUserAction;
}());
//# sourceMappingURL=userActionCollection.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/cjs/userActionCollection.js
// module id = 382
// module chunks = 0